import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, min } from 'rxjs';
import { PurchaseOrder } from '../models/purchase-order';
import { PurchaseOrderItem } from '../models/purchase-order-item.model';
import { Supplier } from '../models/supplier.model';
import { SupplierItem } from '../models/supplier-item.model';

@Injectable({
  providedIn: 'root'
})
export class InventoryService extends CommonService {
  token: string;
  constructor(
    private httpClient: HttpClient,
  ) { 
    super(httpClient);
    this.token = sessionStorage.getItem('token') || '';
  }

  getStock(data: any = {}) {
    const options = this.getHeaders(this.token);
    console.log("options ==========> ", options);
    return this.httpClient.get<any>(`${this.apiURL}/stocks/?${this.parseQueryParams(data)}`, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((stockData: any) => {
      const stocks: any[] = [];
      if (stockData?.data) {
        stockData.data.forEach((stock: any) => {
          const stockItem: any = {
            id: stock.id,
            name: stock.attributes.name,
            categories: stock.attributes.categories,
            quantity: stock.attributes.quantity,
            minimum_threshold: stock.attributes.minimum_threshold,
            unit_of_measure: stock.attributes.unit_of_measure,
            sku: stock.attributes.sku,
            profile: stock.attributes.profile,
            unit_price: stock.attributes.unit_price,
            created_at: stock.attributes.created_at,
            updated_at: stock.attributes.updated_at
          };
          stocks.push(stockItem);
        });
      }
      return { data: stocks, meta: stockData.meta };
    }));
  }

  getStockById(id: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/stocks/${id}`, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((stockData: any) => {
      const stock: any = {
        id: stockData.data.id,
        name: stockData.data.attributes.name,
        categories: stockData.data.attributes.categories,
        quantity: stockData.data.attributes.quantity,
        minimun_threshold: stockData.data.attributes.minimun_threshold,
        unit_of_measure: stockData.data.attributes.unit_of_measure,
        sku: stockData.data.attributes.sku,
        unit_price: stockData.data.attributes.unit_price,
        created_at: stockData.data.attributes.created_at,
        updated_at: stockData.data.attributes.updated_at
      };
      return stock;
    }));
  }

  createStock(data: any) {
  const options = this.getHeaders(this.token);
  return this.httpClient.post<any>(`${this.apiURL}/stocks`, data, options)
  .pipe(catchError(this.errorHandler))
  .pipe(map((stockData: any) => {
    const stock: any = {
      id: stockData.data.id,
      name: stockData.data.attributes.name,
      categories: stockData.data.attributes.categories,
      quantity: stockData.data.attributes.quantity,
      minimum_threshold: stockData.data.attributes.minimum_threshold,
      unit_of_measure: stockData.data.attributes.unit_of_measure,
      sku: stockData.data.attributes.sku,
      profile: stockData.data.attributes.profile,
      unit_price: stockData.data.attributes.unit_price,
      created_at: stockData.data.attributes.created_at,
      updated_at: stockData.data.attributes.updated_at
    };
    return stock;
  }));
}

updateStock(id: number, data: any) {
  const options = this.getHeaders(this.token);
  return this.httpClient.put<any>(`${this.apiURL}/stocks/${id}`, data, options)
  .pipe(catchError(this.errorHandler))
  .pipe(map((stockData: any) => {
    const stock: any = {
      id: stockData.data.id,
      name: stockData.data.attributes.name,
      categories: stockData.data.attributes.categories,
      quantity: stockData.data.attributes.quantity,
      minimum_threshold: stockData.data.attributes.minimum_threshold,
      unit_of_measure: stockData.data.attributes.unit_of_measure,
      sku: stockData.data.attributes.sku,
      profile: stockData.data.attributes.profile,
      unit_price: stockData.data.attributes.unit_price,
      created_at: stockData.data.attributes.created_at,
      updated_at: stockData.data.attributes.updated_at
    };
    return stock;
  }));
}

deleteStock(id: number) {
  const options = this.getHeaders(this.token);
  return this.httpClient.delete<any>(`${this.apiURL}/stocks/${id}`, options)
  .pipe(catchError(this.errorHandler));
}

  getParts(query: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/inventories/part/?category_detail=${query.details}&location_detail=${query.location_detail}&limit=${query.per_page}&offset=${query.page}`, options);    
  }

  getClients(data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/inventories/companies/?${this.parseQueryParams(data)}`, options);
  }

  createClient(data: any) {
    return this.httpClient.post<any>(`${this.apiURL}/inventory/companies/`, data);
  }

  getCompanies(data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/inventories/companies`, options);
  }

  createCompany(id: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.post<any>(`${this.apiURL}/inventory/companies/${id}`, options);
  }

  getPartById(id: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/api/part/${id}/?path_detail=true`, options);
  }

  getSuppliers(query: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/suppliers`, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((supplierData: any) => {
      const suppliers: Supplier[] = [];
      if (supplierData?.data) {
        supplierData.data.forEach((supplier: any) => {
          const supplierItems: SupplierItem[] = [];
          if (supplier.attributes.supplier_items) {
            supplier.attributes.supplier_items.forEach((item: any) => {
              const supplierItem: SupplierItem = {
                id: item.id,
                supplier_id: item?.supplier_id,
                stock_id: item?.stock_id,
                name: item?.name,
                code: item?.code,
                unit_price: item?.unit_price,
                minimum_order_quantity: item?.minimum_order_quantity,
                active: item?.active,
                created_at: item?.created_at,
                updated_at: item?.updated_at,
              };
              supplierItems.push(supplierItem);
            });
          }
          const supplierObj: Supplier = {
            id: supplier.id,
            name: supplier.attributes.name,
            last_name: supplier.attributes.last_name,
            email: supplier.attributes.email,
            phone: supplier.attributes.phone,
            service: supplier.attributes.service,
            avatar: supplier.attributes.avatar,
            active: supplier.attributes.active,
            created_at: supplier.attributes.created_at,
            updated_at: supplier.attributes.updated_at,
            profile: supplier.attributes.profile,
            supplier_items: supplierItems
          };
          suppliers.push(supplierObj);
        });
      }
      return { data: suppliers, meta: supplierData.meta };
    }));
  }

  getSupplierById(id: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/suppliers/${id}`, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((supplierData: any) => {

      const supplierItems: SupplierItem[] = [];
      if (supplierData?.data?.attributes?.supplier_items) {
        supplierData.data.attributes.supplier_items.forEach((item: any) => {
          const supplierItem: SupplierItem = {
            id: item.id,
            supplier_id: item?.supplier_id,
            stock_id: item?.stock_id,
            name: item?.name,
            code: item?.code,
            unit_price: item?.unit_price,
            minimum_order_quantity: item?.minimum_order_quantity,
            active: item?.active,
            created_at: item?.created_at,
            updated_at: item?.updated_at,
          };
          supplierItems.push(supplierItem);
        });
      }

      console.log("supplierItems ==========> ", supplierItems);

      const supplier: any = {
        id: supplierData?.data?.id,
        name: supplierData?.data?.attributes?.name,
        last_name: supplierData?.data?.attributes?.last_name,
        email: supplierData?.data?.attributes?.email,
        phone: supplierData?.data?.attributes?.phone,
        service: supplierData?.data?.attributes?.service,
        avatar: supplierData?.data?.attributes?.avatar,
        created_at: supplierData?.data?.attributes?.created_at,
        updated_at: supplierData?.data?.attributes?.updated_at,
        profile: supplierData?.data?.attributes?.profile,
        supplier_items: supplierItems,
      };
      return supplier;
    }
    ));
  }

  createSupplier(data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.post<any>(`${this.apiURL}/suppliers`, data, options);
  }

  updateSupplier(id: number, data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.put<any>(`${this.apiURL}/suppliers/${id}`, data, options);
  }

  getSupplierItems(id: any, query: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/suppliers/${id}/supplier_items`, options);
  }

  updateSupplierItem(id: any, itemId: any, data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.put<any>(`${this.apiURL}/suppliers/${id}/supplier_items/${itemId}`, data, options)
    .pipe(catchError(this.errorHandler));
  }

  createSupplierItem(id: any, data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.post<any>(`${this.apiURL}/suppliers/${id}/supplier_items`, data, options);
  }

  deleteSupplierItem(supplierId: number, itemId: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.delete<any>(`${this.apiURL}/suppliers/${supplierId}/supplier_items/${itemId}`, options)
    .pipe(catchError(this.errorHandler));
  }

  getCategoriesById(id: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/api/part/category/${id}/`, options);
  }

  getLocationsById(id: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/api/stock/location/${id}/`, options);
  }

  getPricingByPartId(id: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/api/part/${id}/pricing/`, options);
  }

  getPurchaseOrders(data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/purchase_orders/?${this.parseQueryParams(data)}`, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((poData: any) => {
      const purchaseOrders: PurchaseOrder[] = [];
      if (poData?.data) {
        poData.data.forEach((po: any) => {
          const poItems: PurchaseOrderItem[] = [];
          if (po.included?.purchase_order_items) {
            po.included.purchase_order_items.forEach((item: any) => {
              const poItem: PurchaseOrderItem = {
                id: item.id,
                purchase_order_id: item?.attributes?.purchase_order_id,
                supplier_item_id: item?.attributes?.supplier_item_id,
                stock_id: item?.attributes?.stock_id,
                quantity: item?.attributes?.quantity,
                unit_price: item?.attributes?.unit_price,
                total: item?.attributes?.total
              };
              poItems.push(poItem);
            });
          }
          const purchaseOrder: PurchaseOrder = {
            id: po.id,
            po_number: po.attributes.po_number,
            settlement_id: po.attributes.settlement_id,
            status: po.attributes.status,
            total_amount: po.attributes.total_amount,
            notes: po.attributes.notes,
            profile_id: po.attributes.profile_id,
            created_by: po.attributes.created_by,
            approved_by: po.attributes.approved_by,
            supplier: po.attributes.suppliers,
            purchase_order_items: poItems
          };
          purchaseOrders.push(purchaseOrder);
        });
      }
      return { data: purchaseOrders, meta: poData.meta };
    }
    ));
  }

  getPurchaseOrderById(id: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/purchase_orders/${id}`, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((poData: any) => {
      const poItems: PurchaseOrderItem[] = [];
      if (poData?.data?.attributes?.purchase_order_items) {
        poData.data.attributes.purchase_order_items.forEach((item: any) => {
          const poItem: PurchaseOrderItem = {
            id: item?.id,
            purchase_order_id: item?.purchase_order_id,
            supplier_item_id: item?.supplier_item_id,
            stock: item?.stock,
            supplier_item: item?.supplier_item,
            quantity: item?.quantity,
            unit_price: item?.unit_price,
            total: item?.total
          };
          poItems.push(poItem);
        });
      }


      const purchaseOrder: PurchaseOrder = {
        id: poData.data?.id,
        po_number: poData?.data?.attributes?.po_number,
        settlement_id: poData?.data?.attributes?.settlement_id,
        status: poData?.data?.attributes?.status,
        total_amount: poData?.data?.attributes?.total_amount,
        notes: poData?.data?.attributes?.notes,
        profile_id: poData?.data?.attributes?.profile_id,
        created_by: poData?.data?.attributes?.created_by,
        approved_by: poData?.data?.attributes?.approved_by,
        supplier: poData?.data?.attributes?.suppliers,
        created_at: poData?.data?.attributes?.created_at,
        updated_at: poData?.data?.attributes?.updated_at,
        purchase_order_items: poItems
      }
      return purchaseOrder
    }
    ));
  }

  updatePurchaseOrder(id: number, data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.put<any>(`${this.apiURL}/purchase_orders/${id}`, data, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((poData: any) => {
      const poItems: PurchaseOrderItem[] = [];
      if (poData?.data?.attributes?.purchase_order_items) {
        poData.data.attributes.purchase_order_items.forEach((item: any) => {
          const poItem: PurchaseOrderItem = {
            id: item.id,
            purchase_order_id: item?.purchase_order_id,
            supplier_item_id: item?.supplier_item_id,
            stock: item?.stock,
            supplier_item: item?.supplier_item,
            quantity: item?.quantity,
            unit_price: item?.unit_price,
            total: item?.total
          };
          poItems.push(poItem);
        });
      }
      const purchaseOrder: PurchaseOrder = {
        id: poData.id,
        po_number: poData?.data?.attributes?.po_number,
        settlement_id: poData?.data?.attributes?.settlement_id,
        status: poData?.data?.attributes?.status,
        total_amount: poData?.data?.attributes?.total_amount,
        notes: poData?.data?.attributes?.notes,
        profile_id: poData?.data?.attributes?.profile_id,
        created_by: poData?.data?.attributes?.created_by,
        approved_by: poData?.data?.attributes?.approved_by,
        supplier: poData?.data?.attributes?.suppliers,
        purchase_order_items: poItems
      }
      return purchaseOrder;
    }
    ));
  }

  updatePurchaseOrderStatus(id: number, data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.patch(`${this.apiURL}/purchase_orders/${id}/${data}`, { id: id }, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((poData: any) => {
      const poItems: PurchaseOrderItem[] = [];
      if (poData?.data?.attributes?.purchase_order_items) {
        poData.data.attributes.purchase_order_items.forEach((item: any) => {
          const poItem: PurchaseOrderItem = {
            id: item.id,
            purchase_order_id: item?.purchase_order_id,
            supplier_item_id: item?.supplier_item_id,
            stock: item?.stock,
            supplier_item: item?.supplier_item,
            quantity: item?.quantity,
            unit_price: item?.unit_price,
            total: item?.total
          };
          poItems.push(poItem);
        });
      }
      const purchaseOrder: PurchaseOrder = {
        id: poData.id,
        po_number: poData?.data?.attributes?.po_number,
        settlement_id: poData?.data?.attributes?.settlement_id,
        status: poData?.data?.attributes?.status,
        total_amount: poData?.data?.attributes?.total_amount,
        notes: poData?.data?.attributes?.notes,
        profile_id: poData?.data?.attributes?.profile_id,
        created_by: poData?.data?.attributes?.created_by,
        approved_by: poData?.data?.attributes?.approved_by,
        supplier: poData?.data?.attributes?.suppliers,
        purchase_order_items: poItems
      }
      return purchaseOrder;
    }
    ));
  }

  getPurchaseOrderLineItems(id: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/order/po-line/?order=${id}&part_detail=true&limit=25&offset=0`, options);
  }

  getPurchaseOrderReceivedStock(id: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/stock/?purchase_order=${id}&part_detail=true&location_detail=true&supplier_part_detail=true`, options);    
  }

  addPurchaseOrderLineItem(id: any, data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.post<any>(`${this.apiURL}/purchase_orders/${id}/purchase_order_items`, data, options)
  }

  createPurchaseOrder(data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.post<any>(`${this.apiURL}/purchase_orders`, data, options);
  }

  getCategories(query: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/api/part/category/?top_level=true&limit=${query.per_page}&offset=${query.page}`, options);
  }

  searchSupplierItems(query: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/suppliers/?search=${query.search}&limit=${query.per_page}&offset=${query.page}`, options);
  }

  getSupplierItemsByStock(stockId: string) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get(
      `${this.apiURL}/stocks/${stockId}/supplier_items`,
      options
    ).pipe(catchError(this.errorHandler));
  }

  getSales(data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/sales/?${this.parseQueryParams(data)}`, options)
    .pipe(catchError(this.errorHandler)) 
    .pipe(map((saleData: any) => {
      const sales: any[] = [];
      if (saleData?.data) {
        saleData.data.forEach((sale: any) => {
          const saleItem: any = {
            id: sale.id,
            sale_number: sale.attributes.sale_number,
            total_amount: sale.attributes.total_amount,
            status: sale.attributes.status,
            notes: sale.attributes.notes,
            created_at: sale.attributes.created_at,
            updated_at: sale.attributes.updated_at
          };
          sales.push(saleItem);
        });
      }
      return { data: sales, meta: saleData.meta };
    }));
  }
  
  getSaleById(id: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/sales/${id}`, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((saleData: any) => {
      const sale: any = {
        id: saleData.data.id,
        sale_number: saleData.data.attributes.sale_number,
        total_amount: saleData.data.attributes.total_amount,
        status: saleData.data.attributes.status,
        notes: saleData.data.attributes.notes,
        created_at: saleData.data.attributes.created_at,
        updated_at: saleData.data.attributes.updated_at
      };
      return sale;
    }));
  }

  createSale(data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.post<any>(`${this.apiURL}/sales`, data, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((saleData: any) => {
      const sale: any = {
        id: saleData.data.id,
        sale_number: saleData.data.attributes.sale_number,
        total_amount: saleData.data.attributes.total_amount,
        status: saleData.data.attributes.status,
        notes: saleData.data.attributes.notes,
        created_at: saleData.data.attributes.created_at,
        updated_at: saleData.data.attributes.updated_at
      };
      return sale;
    }));
  }

  updateSale(id: number, data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.put<any>(`${this.apiURL}/sales/${id}`, data, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((saleData: any) => {
      const sale: any = {
        id: saleData.data.id,
        sale_number: saleData.data.attributes.sale_number,
        total_amount: saleData.data.attributes.total_amount,
        status: saleData.data.attributes.status,
        notes: saleData.data.attributes.notes,
        created_at: saleData.data.attributes.created_at,
        updated_at: saleData.data.attributes.updated_at
      };
      return sale;
    }));
  }

  deleteSale(id: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.delete<any>(`${this.apiURL}/sales/${id}`, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((response: any) => {
      return response;
    }));
  }

  getSaleItems(saleId: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/sales/${saleId}/sale_items`, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((saleItemData: any) => {
      const saleItems: any[] = [];
      if (saleItemData?.data) {
        saleItemData.data.forEach((item: any) => {
          const saleItem: any = {
            id: item.id,
            sale_id: item.attributes.sale_id,
            stock_id: item.attributes.stock_id,
            quantity: item.attributes.quantity,
            unit_price: item.attributes.unit_price,
            total: item.attributes.total,
            created_at: item.attributes.created_at,
            updated_at: item.attributes.updated_at
          };
          saleItems.push(saleItem);
        });
      }
      return { data: saleItems, meta: saleItemData.meta };
    }));
  }
  createSaleItem(saleId: number, data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.post<any>(`${this.apiURL}/sales/${saleId}/sale_items`, data, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((saleItemData: any) => {
      const saleItem: any = {
        id: saleItemData.data.id,
        sale_id: saleItemData.data.attributes.sale_id,
        stock_id: saleItemData.data.attributes.stock_id,
        quantity: saleItemData.data.attributes.quantity,
        unit_price: saleItemData.data.attributes.unit_price,
        total: saleItemData.data.attributes.total,
        created_at: saleItemData.data.attributes.created_at,
        updated_at: saleItemData.data.attributes.updated_at
      };
      return saleItem;
    }));
  }

  updateSaleItem(saleId: number, itemId: number, data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.put<any>(`${this.apiURL}/sales/${saleId}/sale_items/${itemId}`, data, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((saleItemData: any) => {
      const saleItem: any = {
        id: saleItemData.data.id,
        sale_id: saleItemData.data.attributes.sale_id,
        stock_id: saleItemData.data.attributes.stock_id,
        quantity: saleItemData.data.attributes.quantity,
        unit_price: saleItemData.data.attributes.unit_price,
        total: saleItemData.data.attributes.total,
        created_at: saleItemData.data.attributes.created_at,
        updated_at: saleItemData.data.attributes.updated_at
      };
      return saleItem;
    }));
  }

  deleteSaleItem(saleId: number, itemId: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.delete<any>(`${this.apiURL}/sales/${saleId}/sale_items/${itemId}`, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((response: any) => {
      return response;
    }));
  }

  getSaleItemById(saleId: number, itemId: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/sales/${saleId}/sale_items/${itemId}`, options)
    .pipe(catchError(this.errorHandler))
    .pipe(map((saleItemData: any) => {
      const saleItem: any = {
        id: saleItemData.data.id,
        sale_id: saleItemData.data.attributes.sale_id,
        stock_id: saleItemData.data.attributes.stock_id,
        quantity: saleItemData.data.attributes.quantity,
        unit_price: saleItemData.data.attributes.unit_price,
        total: saleItemData.data.attributes.total,
        created_at: saleItemData.data.attributes.created_at,
        updated_at: saleItemData.data.attributes.updated_at
      };
      return saleItem;
    }));
  }

  getStockAssignments(data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/stock_assignments/?${this.parseQueryParams(data)}`, options)
    .pipe(catchError(this.errorHandler))
  }

  getUserStockAssignments(userId: number) {
    const options = this.getHeaders(this.token);
    return this.httpClient.get<any>(`${this.apiURL}/users/${userId}/assignments`, options)
  }

  // PUT /stock_assignments/:id
  assignStockToUser(data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.post<any>(`${this.apiURL}/stock_assignments`, data, options)
    .pipe(catchError(this.errorHandler));
  }

  // PUT /stock_assignments/:id/return
  returnStockAssignment(userId: number, data: any) {
    const options = this.getHeaders(this.token);
    return this.httpClient.put<any>(`${this.apiURL}/stock_assignments/${userId}/return`, data, options);
  }

}
